/** Hook die het aantal opeenvolgende voltooiingsdagen uit alle taken afleidt. */
import { useMemo } from 'react';
import { calculateCompletionStreak } from '@/features/today/utils/completionStreakUtils';

/**
 * @param {import('@/types').Task[]} allTasks
 * @returns {number}
 */
export function useCompletionStreak(allTasks) {
  return useMemo(() => calculateCompletionStreak(allTasks), [allTasks]);
}
